/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdjustDisputedAmountRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {AdjustDisputedAmountResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const adjustDisputedAmount = (request: AdjustDisputedAmountRequest, options?: CashRequestOptions) => post<AdjustDisputedAmountRequest, AdjustDisputedAmountResponse>("/2.0/cash/adjust-disputed-amount", request, {...options, rejectOnError: true })